export enum FONT_SIZES {
  px8 = '0.5rem',
  px9 = '0.5625rem',
  px10 = '0.625rem',
  px11 = '0.6875rem',
  px12 = '0.75rem',
  px13 = '0.813rem',
  px14 = '0.875rem',

  px16 = '1rem', // => Base Font size set for the html tag

  px18 = '1.125rem',
  px20 = '1.25rem',
  px22 = '1.375rem',
  px24 = '1.5rem',
  px28 = '1.75rem',
  px32 = '2rem',
  px40 = '2.5rem',
  px46 = '2.875rem',
  px48 = '3rem',
  px54 = '3.375rem',
  px56 = '3.5rem',
  px80 = '5rem',
}

export enum FONT_WEIGHTS {
  light = 'normal',
  mediumBold = 500,
  bold = 600,
  mediumHeavy = 700,
  heavy = 900,
}
